// extracted by mini-css-extract-plugin
var _1 = "n6hir";
export { _1 as "container" }
